import type { ReactNode } from 'react'
import { Spinner } from '@rentflowdev/ui'

export function PropertiesPageCentered({ children }: { children: ReactNode }) {
	return <div className="flex h-full items-center justify-center">{children}</div>
}

export function PropertiesPageLoading() {
	return (
		<PropertiesPageCentered>
			<Spinner />
		</PropertiesPageCentered>
	)
}
